<template>
  <product-management state="2" />
</template>
<script>
export default {
  components: {
    productManagement: () => import('../productManagement/index.vue')
  }
}
</script>